import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';

import {
  getProjectsAll as getProjectsAllAction,
  cancelGetProjectsAll,
} from 'store/services/projects/actions';
import {
  getProjectsAll,
  getIsLoadingAll,
} from 'store/services/projects/selectors';
import { selectProject, exportProject } from 'store/services/project/actions';
import { getProject, getIsExporting } from 'store/services/project/selectors';
import {
  getNotificationsList,
  markNotificationsAsRead,
  refreshNotificationsList,
} from 'store/services/notifications/actions';
import {
  getNotificationsList as getNotificationsListSelector,
  getNotificationsCount,
  getPaginationOptions,
  getIsLoadingList,
} from 'store/services/notifications/selectors';
import { getSidebarIsOpen } from 'store/services/settings/selectors';
import {
  getSpotlightResults as fetchSpotlightResults,
  resetState,
} from 'store/services/spotlight/actions';

import {
  getIsSpotlightLoading,
  getNormalizedResults,
  getIsLoaded,
} from 'store/services/spotlight/selectors';

import { projectType, notificationType } from 'types';

import ExportMenu from 'components/ExportMenu';
import UserMenu from 'components/UserMenu';
import ShortcutsMenu from 'components/ShortcutsMenu';
import BasicHeader from 'components/Header';
import Logo from 'components/Logo';
import HeaderSearch from './components/HeaderSearch';
import ProjectsMenu from './components/ProjectsMenu';
import Notifications from './components/Notifications';
import DeploymentMenu from './components/DeploymentMenu';
import VersionControlMenu from './components/VersionControlMenu';

const styledMenuBase = css`
  align-items: center;
  display: flex;
`;

const StyledLeftMenu = styled.div`
  ${styledMenuBase};
`;

const StyledRightMenu = styled.div`
  ${styledMenuBase};
  justify-content: flex-end;
`;

/* eslint-disable react/destructuring-assignment */

export class CommonHeader extends Component {
  static propTypes = {
    cancelGetProjectsAll: PropTypes.func.isRequired,
    getItems: PropTypes.func.isRequired,
    isExporting: PropTypes.bool.isRequired,
    isSpotlightLoading: PropTypes.bool.isRequired,
    notifications: PropTypes.arrayOf(notificationType).isRequired,
    notificationsCount: PropTypes.number.isRequired,
    notificationsPaginationOptions: PropTypes.shape({
      page: PropTypes.number.isRequired,
      size: PropTypes.number.isRequired,
    }).isRequired,
    projectsAreLoading: PropTypes.bool.isRequired,
    refreshNotificationsList: PropTypes.func.isRequired,
    resetSpotlightState: PropTypes.func.isRequired,
    onExport: PropTypes.func.isRequired,
    onPushToHistory: PropTypes.func.isRequired,
    currentProject: projectType,
    getNotificationsList: PropTypes.func,
    getProjectsAll: PropTypes.func,
    isLoaded: PropTypes.bool,
    isLoadingNotifications: PropTypes.bool,
    isOpen: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.object),
    markNotificationsAsRead: PropTypes.func,
    projects: PropTypes.arrayOf(projectType),
    selectProject: PropTypes.func,
  };

  componentDidMount() {
    if (!this.props.projects.length) {
      this.props.getProjectsAll();
    }
  }

  render() {
    const {
      isOpen,
      isExporting,
      getProjectsAll,
      cancelGetProjectsAll,
      projects,
      projectsAreLoading,
      currentProject,
      isSpotlightLoading,
      items,
      notifications,
      notificationsCount,
      notificationsPaginationOptions,
      isLoadingNotifications,
      selectProject,
      getItems,
      resetSpotlightState,
      onExport,
      getNotificationsList,
      markNotificationsAsRead,
      refreshNotificationsList,
      onPushToHistory,
      isLoaded,
    } = this.props;

    return (
      <BasicHeader
        center={
          <HeaderSearch
            currentProject={currentProject}
            getItems={getItems}
            isLoaded={isLoaded}
            isLoading={isSpotlightLoading}
            items={items}
            resetState={resetSpotlightState}
            onPushToHistory={onPushToHistory}
          />
        }
        left={
          <StyledLeftMenu>
            <Link to="/">
              <Logo isOpen={isOpen} />
            </Link>
            <ProjectsMenu
              cancelGetProjectsAll={cancelGetProjectsAll}
              currentProject={currentProject}
              getProjectsAll={getProjectsAll}
              projects={projects}
              projectsAreLoading={projectsAreLoading}
              selectProject={selectProject}
            />
          </StyledLeftMenu>
        }
        right={
          <StyledRightMenu>
            <VersionControlMenu onPushToHistory={onPushToHistory} />

            <DeploymentMenu />

            <ExportMenu isExporting={isExporting} onExport={onExport} />

            <ShortcutsMenu />

            <Notifications
              count={notificationsCount}
              isLoading={isLoadingNotifications}
              notifications={notifications}
              paginationOptions={notificationsPaginationOptions}
              onGetNotifications={getNotificationsList}
              onMarkNotificationsAsRead={markNotificationsAsRead}
              onRefreshNotifications={refreshNotificationsList}
            />
            <UserMenu />
          </StyledRightMenu>
        }
      />
    );
  }
}

const mapStateToProps = state => ({
  isOpen: getSidebarIsOpen(state),
  items: getNormalizedResults(state),
  isLoaded: getIsLoaded(state),
  isSpotlightLoading: getIsSpotlightLoading(state),
  projects: getProjectsAll(state),
  currentProject: getProject(state),
  notifications: getNotificationsListSelector(state),
  notificationsCount: getNotificationsCount(state),
  notificationsPaginationOptions: getPaginationOptions(state),
  isLoadingNotifications: getIsLoadingList(state),
  isExporting: getIsExporting(state),
  projectsAreLoading: getIsLoadingAll(state),
});

const mapDispatchToProps = {
  getItems: fetchSpotlightResults,
  resetSpotlightState: resetState,
  selectProject,
  getNotificationsList,
  markNotificationsAsRead,
  refreshNotificationsList,
  onExport: exportProject,
  getProjectsAll: getProjectsAllAction,
  cancelGetProjectsAll,
};

export default compose(
  withRouter,
  withProps(({ history }) => ({
    onPushToHistory: history.push,
  })),
  connect(mapStateToProps, mapDispatchToProps),
)(CommonHeader);
